module.exports = __webpack_public_path__ + "d1.no2.84f59723.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/d1.no2.jpg
// module id = Fw/F
// module chunks = 0